<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./submission.store";
  import { submissionDtoFields } from "../../utils/TableFields/submission-dto.fields";
  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  import ClassroomDropdown from "../../components/Business/ClassroomDropdown.svelte";
  import ChallengeDropdown from "../../components/Business/ChallengeDropdown.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="submission"
    entityPlural="submissions"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    searchFieldVisible={false}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
    <div slot="search" class="submission-search-box">
      <div style="min-width: 15rem;">
        <ChallengeDropdown
          name=""
          placeholder="challenge"
          required={false}
          clearVisible={true}
          bind:value={$filter.criteria.challengeId}
          on:select={search}
          on:clear={search}
        />
      </div>
      <div style="min-width: 15rem;">
        <ClassroomDropdown
          name=""
          placeholder="classroom"
          required={false}
          clearVisible={true}
          bind:value={$filter.criteria.classroomId}
          on:select={search}
          on:clear={search}
        />
      </div>
      <div style="min-width: 15rem;">
        <PortalUserDropdown
          name=""
          placeholder="user"
          required={false}
          clearVisible={true}
          bind:value={$filter.criteria.portalUserId}
          on:select={search}
          on:clear={search}
        />
      </div>
      <div style="padding-top: 3px;">
        <Switch name="" altText="Show best submissions per user" bind:value={$filter.criteria.bestOnly} on:toggle={search} />
      </div>
      <!--
      <div>
        <Button on:click={search}>
          <Icon name="search" />
          <span> Search </span>
        </Button>
      </div>
      -->
    </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={submissionDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={false}
    editEnabled={true}
    deleteEnabled={false}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>

<style>
  .submission-search-box {
    display: flex;
    flex-direction: row;
  }
  .submission-search-box div {
    padding-right: 0.75rem;
  }
</style>
